"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-unused-vars
const vue_property_decorator_1 = require("vue-property-decorator");
let ViewZeroCodes = class ViewZeroCodes extends vue_property_decorator_1.Vue {
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 404 })
], ViewZeroCodes.prototype, "codeError", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'Opss!' })
], ViewZeroCodes.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], ViewZeroCodes.prototype, "module", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: 'This certificate has changed its status as private, please contact its owner to make it public.',
    })
], ViewZeroCodes.prototype, "subtitle", void 0);
ViewZeroCodes = __decorate([
    (0, vue_property_decorator_1.Options)({})
    // eslint-disable-next-line no-unused-vars
], ViewZeroCodes);
exports.default = ViewZeroCodes;
